import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login'
import Home from '../views/Home'
import Scanner from '../views/Scanner'
import Checkout from '../views/Checkout'
import BootstrapVue from "bootstrap-vue"
import { auth } from 'firebase';

Vue.use(BootstrapVue);
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/scanner',
    name: 'Scanner',
    component: Scanner,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/checkout/:orderid',
    name: 'Checkout',
    component: Checkout,
    meta: {
      requireAuth: true
    }
  }
]

const router = new VueRouter({
  // mode: "history",
  routes
})

router.beforeEach((to, from, next)=> {
  const currentUser = auth().currentUser;
  const requireAuth = to.matched.some(record => record.meta.requireAuth);
  if(requireAuth && !currentUser){
    next('login');
  } else if (!requireAuth && currentUser){
    next('scanner');
  } else {
    next()
  }
})

export default router
